import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
// Constants
import {
  ABOUT_PAGE_URL,
  CONTACT_PAGE_URL,
  COOKIE_TIMER,
  CookiePolicyName,
  GALLERY_PAGE_URL,
  HOME_PAGE_URL,
  MAINTENANCE_PAGE_URL,
  POLICIES_PAGE_URL,
  SESSIONS_PAGE_URL,
  INDEX_PAGE_URL,
  FANSITES_PAGE_URL,
  CLIPS_PAGE_URL,
} from './utils/Constants';
// Auth
// Components
import LoadingScreen from './components/utils/LoadingScreen';
import HomePage from './pages/home/HomePage';
import AboutPage from './pages/about/AboutPage';
import IndexPage from './pages/index/IndexPage';
import SessionsPage from './pages/sessions/SessionsPage';
import GalleryPage from './pages/gallery/GalleryPage';
import MaintenancePage from './pages/maintenance/MaintenancePage';
import ContactPage from './pages/contact/ContactPage';
import TermAndPoliciesPage from './pages/policies/TermAndPoliciesPage';
import Error404 from './pages/error/Error404';
import FansitesPage from './pages/fansites/FansitesPage';

const CookieConsentModal = lazy(() =>
  import('./components/modals/CookieConsentModal')
);

function App() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasAgreedToCookies, setHasAgreedToCookies] = useState(true);

  useEffect(() => {
    const cookie = localStorage.getItem(CookiePolicyName);
    setHasAgreedToCookies(!!cookie);
  }, []);

  useEffect(() => {
    if (hasAgreedToCookies) {
      setIsVisible(false);
    } else {
      const timer = setTimeout(() => setIsVisible(true), COOKIE_TIMER);
      return () => clearTimeout(timer);
    }
  }, [hasAgreedToCookies]);

  return (
    <>
      {isVisible && (
        <Suspense fallback={<LoadingScreen />}>
          <CookieConsentModal setHasAgreedToCookies={setHasAgreedToCookies} />
        </Suspense>
      )}

      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path={INDEX_PAGE_URL} index element={<IndexPage />} />
          <Route path={HOME_PAGE_URL} element={<HomePage />} />
          <Route path={ABOUT_PAGE_URL} element={<AboutPage />} />
          <Route path={GALLERY_PAGE_URL} element={<GalleryPage />} />
          <Route path={SESSIONS_PAGE_URL} element={<SessionsPage />} />
          <Route path={FANSITES_PAGE_URL} element={<FansitesPage />} />
          <Route path={CONTACT_PAGE_URL} element={<ContactPage />} />

          <Route path={POLICIES_PAGE_URL} element={<TermAndPoliciesPage />} />
          <Route path={MAINTENANCE_PAGE_URL} element={<MaintenancePage />} />

          <Route path='*' element={<Error404 />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
